module.exports = __webpack_public_path__ + "img/avatar5.a8d5ab92.jpg";